import RatingView from './Rating'
import { compose, mapProps, withHandlers } from 'recompose'
import withBazaarVoiceRatingFromStore from 'components/common/hoc/withBazaarVoiceInlineRatings/withBazaarVoiceRatingFromStore'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

const navigateToReviewsAnchor = link => (dispatch) => {
  dispatch(push(link))
}

const withCheckRatingCount = mapProps(({ ratingCount, ...props }) => ({
  ...props,
  ratingCount: ratingCount || 0
}))

const withSetHandler = mapProps(({ handler, handleRatingClick, reviewsLink, ...props }) => ({
  ...props,
  handleRatingClick,
  reviewsLink,
  handler: reviewsLink ? handleRatingClick : handler
}))

const withReviewsClickHandler = withHandlers({
  handleRatingClick: ({
    reviewsLink,
    navigateToReviewsAnchor
  }) => () => {
    navigateToReviewsAnchor(reviewsLink)
  }
})

const Rating = withCheckRatingCount(RatingView)
export default Rating

export const BazaarVoiceRating = compose(
  connect(null, { navigateToReviewsAnchor }),
  withBazaarVoiceRatingFromStore,
  withReviewsClickHandler,
  withSetHandler
)(Rating)
